import { FC, ReactNode } from 'react';
import {createPortal} from 'react-dom'
import {Modal as Modal_} from 'react-bootstrap'

interface Props {
  children: ReactNode
  dialogClassName: string
  show: boolean
  handleClose: () => void
  title?: string
  modalBodyClassName?: string
}
  
const modalsRoot = document.getElementById('root-modals') || document.body

const Modal: FC<Props> = ({ children, show, handleClose, dialogClassName, title, modalBodyClassName }) => {

return createPortal(
    <Modal_
      tabIndex={-1}
      dialogClassName={`modal-dialog mx-sm-6 mx-lg-auto modal-dialog-centered ${dialogClassName}`}
      show={show}
      onHide={handleClose}
      backdrop={true}
      enforceFocus={false}
    >
    {title && (
      <div className='modal-header py-5'>
        <h2 className="mb-0">{title}</h2>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='fa-solid fa-xmark fs-1'/>
        </div>
      </div>
    )}

    <div className={`modal-body ${modalBodyClassName}`}>
        {children}
    </div>
    </Modal_>,
    modalsRoot
  )
}
  
export {Modal}